/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    opencollective: {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" fill-opacity=".4" d="M12.995 8.195c0 .937-.312 1.912-.78 2.693l1.99 1.99c.976-1.327 1.6-2.966 1.6-4.683 0-1.795-.624-3.434-1.561-4.76l-2.068 2.028c.468.781.78 1.679.78 2.732z"/><path pid="1" d="M8 13.151a4.995 4.995 0 110-9.99c1.015 0 1.951.273 2.732.82l1.95-2.03a7.805 7.805 0 10.04 12.449l-1.951-2.03a5.07 5.07 0 01-2.732.781z"/>',
    },
});
